import axios from 'axios';
import { config } from '../../config';

export default {
    namespaced: true, // ← IMPORTANTE: Activa el namespacing para este módulo

    actions: {
        async variable_getByName(_, formData) {
            return new Promise((resolve, reject) => {
                axios.get(config.apiUrl + '/variable/get/'+formData.nombre)
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async variable_update(_, formData) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl + '/variable/update', formData)
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        }
    }
}